module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-100.93bb28c7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-100.png
// module id = 3339
// module chunks = 11